import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { RequestDataPickerComponent } from './request-data-picker.component';

@NgModule({
  declarations: [
    RequestDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    RequestDataPickerComponent
  ]
})
export class RequestDataPickerModule { }
